import {EMPTY_ARRAY} from '~/shared/consts/commonConsts';

import {AppState} from '../../configStore';

export const selectDialogErrors = (state: AppState) => state.errorDialogData || EMPTY_ARRAY;
